import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';

import {
  UPDATE_RIDE_FARE_START,
  UPDATE_RIDE_FARE_SUCCESS,
  UPDATE_RIDE_FARE_ERROR
} from '../../../constants';
import history from '../../../history';
import { setLoaderStart, setLoaderComplete } from '../../loader/loader';

const mutation = gql`
mutation updateRideFare(
  $id: Int,
  $categoryId: Int!,
  $locationId: Int!,
  $unitPrice: Float,
  $minutePrice: Float,
  $basePrice: Float,
  $currency: String!,
  $riderFeeValue: Float,
  $driverFeeValue: Float,
  $isActive: Boolean,
  $isSurgePrice: Boolean,
  $baseFare: Float,
  $waitingPrice: Float,
  $surgePricing: String
) {
  updateRideFare(
    id: $id,
    categoryId: $categoryId,
    locationId: $locationId,
    unitPrice: $unitPrice,
    minutePrice: $minutePrice,
    basePrice: $basePrice,
    currency: $currency,
    riderFeeValue: $riderFeeValue,
    driverFeeValue: $driverFeeValue,
    isActive: $isActive,
    isSurgePrice: $isSurgePrice,
    baseFare: $baseFare,
    waitingPrice: $waitingPrice,
    surgePricing: $surgePricing
  ) {
    status
    errorMessage
  }
}
`;

export default function updateRideFare(values) {
  return async (dispatch, getState, { client }) => {
    try {
      dispatch({ type: UPDATE_RIDE_FARE_START });
      dispatch(setLoaderStart('RideFareForm'));

      const isSurgePrice = values.isSurgePrice == true || values.isSurgePrice == 'true';

      // Select inputs hand back strings, while the surge columns are numeric and
      // boolean, so every window is coerced before it is sent.
      const surgeRows = isSurgePrice
        ? (values.surgePricing || []).map(row => {
          const pricingType = Number(row.pricingType);

          return {
            id: row.id ? Number(row.id) : undefined,
            pricingType,
            dayPricingValue: pricingType === 2 ? row.dayPricingValue : null,
            datePricingValue: pricingType === 1 ? row.datePricingValue : null,
            startTime: Number(row.startTime),
            endTime: Number(row.endTime),
            surgeValue: Number(row.surgeValue),
            isEnable: row.isEnable == true || row.isEnable == 'true'
          };
        })
        : [];

      const variables = {
        id: values.id ? Number(values.id) : undefined,
        categoryId: Number(values.categoryId),
        locationId: Number(values.locationId),
        unitPrice: Number(values.unitPrice),
        minutePrice: Number(values.minutePrice),
        basePrice: Number(values.basePrice),
        currency: values.currency,
        riderFeeValue: Number(values.riderFeeValue),
        driverFeeValue: Number(values.driverFeeValue),
        isActive: values.isActive == true || values.isActive == 'true',
        isSurgePrice,
        baseFare: Number(values.baseFare),
        waitingPrice: Number(values.waitingPrice),
        surgePricing: JSON.stringify(surgeRows)
      };

      const { data } = await client.mutate({ mutation, variables });

      if (data && data.updateRideFare && data.updateRideFare.status === 200) {
        dispatch({ type: UPDATE_RIDE_FARE_SUCCESS });
        dispatch(setLoaderComplete('RideFareForm'));
        history.push('/siteadmin/ride-fare');
        toastr.success('Success', values.id ? 'The ride fare has been updated.' : 'The ride fare has been added.');
        return { status: 200 };
      }

      const errorMessage = (data && data.updateRideFare && data.updateRideFare.errorMessage) || 'Oops! Something went wrong. Please try again.';
      dispatch({ type: UPDATE_RIDE_FARE_ERROR, payload: { error: errorMessage } });
      dispatch(setLoaderComplete('RideFareForm'));
      toastr.error('Error!', errorMessage);
      return { status: 400 };

    } catch (error) {
      dispatch({ type: UPDATE_RIDE_FARE_ERROR, payload: { error } });
      dispatch(setLoaderComplete('RideFareForm'));
      toastr.error('Error!', 'Something went wrong! ' + error);
      return { status: 400 };
    }
  };
}
